import { showChannelRequestErrorToast } from 'services/toaster';

interface ChangeEntityDeletedParams {
  /** `true` archives, `false` restores. */
  deleted: boolean;
  /** Marks the entity in its store. */
  markDeleted: (deleted: boolean) => void;
  /** Sends the archive or the restore to the server. */
  sendChange: (deleted: boolean) => Promise<unknown>;
  /** For the error log, e.g. `a site`. */
  entityLabel: string;
}

/**
 * Archives or restores an entity at once in its store; the change is undone
 * and the server's error shown when the server rejects it.
 */
export function changeEntityDeleted({ deleted, markDeleted, sendChange, entityLabel }: ChangeEntityDeletedParams): void {
  markDeleted(deleted);
  sendChange(deleted).catch((error: unknown) => {
    markDeleted(!deleted);
    showChannelRequestErrorToast(`Error while ${deleted ? 'archiving' : 'restoring'} ${entityLabel}`, error);
  });
}
